import React from 'react';
import PostsManager from '@/features/cms/components/PostsManager';

const CmsPostsPage: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <PostsManager />
  </div>
);

export default CmsPostsPage;
